import HomePage from "./pages/HomePage.js";
import "./App.css";
import "./force.css";

function App() {
  return <HomePage />;
}

export default App;
